module.exports = __webpack_public_path__ + "img/Db.4988cd41.png";